import merge from 'lodash/merge';
import {DARK_THEME, LIGHT_THEME} from '@apps-common/ui-theme/Themes';
import {createTheme} from '@mui/material/styles';

import mixins from './mixins.js';
import {getStyleOverrides} from './overrides.js';

const createPLTheme = mode => {
  const darkMode = mode === 'dark';
  const theme = darkMode ? DARK_THEME : LIGHT_THEME;
  const MUITheme = createTheme({
    palette: {
      mode: mode,
    },
  });
  return createTheme(
    merge(theme, {
      palette: {
        // the overrides in ui-theme break too many things
        action: {
          ...MUITheme.palette.action,
        },
      },
      mixins,
      components: {
        ...getStyleOverrides(theme),
      },
    })
  );
};

export default createPLTheme;
